[
  {
    "id": "jTz6aBR-GJ4",
    "title": "НЕ ВАРІТЬ ГАРБУЗ ❌ Приготуйте його так, як ніколи раніше",
    "description": "Осінній випуск із трьома ідеями для гарбуза: закуска, вареники та крем-брюле.",
    "category": "Сезонне",
    "kind": "episode",
    "published": "2026-09-23T16:13:47+00:00",
    "views": 31529,
    "duration": "8 хв",
    "thumbnail": "https://i.ytimg.com/vi/jTz6aBR-GJ4/hq720.jpg",
    "sourceUrl": "https://www.youtube.com/watch?v=jTz6aBR-GJ4",
    "playback": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/jTz6aBR-GJ4.mp4",
      "type": "video/mp4"
    }
  },
  {
    "id": "PZ6P1iqyphM",
    "title": "КІМЧІ: страва, без якої немає корейського столу 😮 КЛОПОТЕНКО & ЛІМ",
    "description": "Розмова про корейську кухню в Україні та рецепт справжнього кімчі.",
    "category": "Кухні світу",
    "kind": "episode",
    "published": "2026-09-16T16:29:04+00:00",
    "views": 133506,
    "duration": "25 хв",
    "thumbnail": "https://i.ytimg.com/vi/PZ6P1iqyphM/hq720.jpg",
    "sourceUrl": "https://www.youtube.com/watch?v=PZ6P1iqyphM",
    "playback": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/PZ6P1iqyphM.mp4",
      "type": "video/mp4"
    }
  },
  {
    "id": "bgF41IjO8dE",
    "title": "Чому в Україні немає десертів? І що СОЛОДКЕ ми насправді їли раніше? КЛОПОТЕНКО & БРАЙЧЕНКО",
    "description": "Історична розмова про солодке, локальні традиції та гастрономічну пам'ять.",
    "category": "Гастроспадок",
    "kind": "special",
    "published": "2026-09-12T14:33:41+00:00",
    "views": 69829,
    "duration": "47 хв",
    "thumbnail": "https://i.ytimg.com/vi/bgF41IjO8dE/hq720.jpg",
    "sourceUrl": "https://www.youtube.com/watch?v=bgF41IjO8dE",
    "playback": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/bgF41IjO8dE.mp4",
      "type": "video/mp4"
    }
  },
  {
    "id": "5pul4HVdIAA",
    "title": "Чому ми готуємо печені яблука саме ТАК? 3 найсмачніші рецепти 🔥",
    "description": "Три способи приготувати печені яблука для домашнього осіннього меню.",
    "category": "Десерти",
    "kind": "episode",
    "published": "2026-09-04T16:54:52+00:00",
    "views": 29363,
    "duration": "6 хв",
    "thumbnail": "https://i.ytimg.com/vi/5pul4HVdIAA/hq720.jpg",
    "sourceUrl": "https://www.youtube.com/watch?v=5pul4HVdIAA",
    "playback": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/5pul4HVdIAA.mp4",
      "type": "video/mp4"
    }
  },
  {
    "id": "SWjDeK9W1UA",
    "title": "❌ Не готуйте так КАРТОПЛЮ: 5 поширених помилок | КЛОПОТЕНКО",
    "description": "Практичний випуск про текстуру, температуру та помилки у приготуванні картоплі.",
    "category": "Поради",
    "kind": "episode",
    "published": "2026-08-31T14:00:13+00:00",
    "views": 275231,
    "duration": "5 хв",
    "thumbnail": "https://i.ytimg.com/vi/SWjDeK9W1UA/hq720.jpg",
    "sourceUrl": "https://www.youtube.com/watch?v=SWjDeK9W1UA",
    "playback": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/SWjDeK9W1UA.mp4",
      "type": "video/mp4"
    }
  },
  {
    "id": "8JX72GmPMww",
    "title": "ХМЕЛЬНИЧЧИНА: легендарна ковбаса, білий борщ, фляки з печі і начинка | Застигла АРИСТОКРАТІЯ",
    "description": "Велика гастрономічна експедиція про локальні рецепти та українську спадщину.",
    "category": "Гастроспадок",
    "kind": "special",
    "published": "2026-08-15T15:00:00+00:00",
    "views": 115267,
    "duration": "50 хв",
    "thumbnail": "https://i.ytimg.com/vi/8JX72GmPMww/hq720.jpg",
    "sourceUrl": "https://www.youtube.com/watch?v=8JX72GmPMww",
    "recipeUrl": "https://klopotenko.com/gastrospadok",
    "playback": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/8JX72GmPMww.mp4",
      "type": "video/mp4"
    }
  },
  {
    "id": "-7AayTChOYY",
    "title": "Маєте черствий хліб? Зробіть з нього ЦЕ 🔥",
    "description": "Швидкий vertical рецепт для перетворення вчорашнього хліба на десерт.",
    "category": "Shorts",
    "kind": "short",
    "published": "2026-09-18T11:00:22+00:00",
    "views": 77122,
    "duration": "2 хв",
    "thumbnail": "https://i.ytimg.com/vi/-7AayTChOYY/hq720.jpg",
    "sourceUrl": "https://www.youtube.com/shorts/-7AayTChOYY",
    "playback": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/-7AayTChOYY.mp4",
      "type": "video/mp4"
    }
  },
  {
    "id": "qrNZ7K396dc",
    "title": "Часникове МАСЛО – це краще, ніж ви очікуєте!",
    "description": "Короткий рецепт для швидкого апгрейду домашніх страв.",
    "category": "Shorts",
    "kind": "short",
    "published": "2026-09-13T12:00:00+00:00",
    "views": 26723,
    "duration": "1 хв",
    "thumbnail": "https://i.ytimg.com/vi/qrNZ7K396dc/hq720.jpg",
    "sourceUrl": "https://www.youtube.com/shorts/qrNZ7K396dc",
    "playback": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/qrNZ7K396dc.mp4",
      "type": "video/mp4"
    }
  },
  {
    "id": "7BAXxbGA3vE",
    "title": "Морозиво всього з ДВОХ складників 🔥 Зберігайте!",
    "description": "Легкий короткий рецепт для літнього або сімейного меню.",
    "category": "Shorts",
    "kind": "short",
    "published": "2026-09-08T12:00:16+00:00",
    "views": 69253,
    "duration": "1 хв",
    "thumbnail": "https://i.ytimg.com/vi/7BAXxbGA3vE/hq720.jpg",
    "sourceUrl": "https://www.youtube.com/shorts/7BAXxbGA3vE",
    "playback": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/7BAXxbGA3vE.mp4",
      "type": "video/mp4"
    }
  },
  {
    "id": "vq5tsmjWDsE",
    "title": "Снек із КУКУРУДЗИ 🔥 Просто спробуйте це!",
    "description": "Формат для короткого перегляду і швидкого повторення на кухні.",
    "category": "Shorts",
    "kind": "short",
    "published": "2026-09-01T12:00:28+00:00",
    "views": 75437,
    "duration": "1 хв",
    "thumbnail": "https://i.ytimg.com/vi/vq5tsmjWDsE/hq720.jpg",
    "sourceUrl": "https://www.youtube.com/shorts/vq5tsmjWDsE",
    "playback": {
      "src": "https://pub-4be8729bb48b4809a49755255baf927b.r2.dev/episodes/vq5tsmjWDsE.mp4",
      "type": "video/mp4"
    }
  }
]
